<template>
<div class="navbar-fixed-content" style="padding-top:70px;">
  <div class="new_index newcontrain">
    <div class="step">
      <a href="/">师资培训</a>
      &gt; {{classData.name}}
    </div>
    <div class="info">
      <img :src="classData.logo" class="banlogo" />
      <div class="ft">
        <div class="name">{{classData.name}}</div>
        <div class="num">
          <div class="span1">
            <img src="Images/icon-scale.png" />
            <span>
              <span id="studentNum"> {{classData.scale}}</span> 人
            </span>
          </div>
          <div class="span3">
            <img src="Images/icon-type.png" />
            <span> {{classData.category}}</span>
          </div>
          <div class="span2">
            <img src="Images/icon-timelong.png" />
            <span> {{classData.timelong}} 天</span>
          </div>
        </div>
        <div class="statue">已参加</div>
        <div class="opr">
          <div class="shareModel" style="position:static">
            <span class="qaaCollection00" @click="collectClass()">
              <span :class="[classData.isCollect?'ischoosed':'','qaaCollection']"></span>
              <span :class="[!classData.isCollect?'ischoosed':'','qaaCollection2']" >取消收藏</span>
              <span
                :class="[classData.isCollect?'ischoosed':'','qaaCollection1']" 
              >收藏</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="kc_box">
      <h2 class="tab-title">
        <span>
          <a v-for="(item,index) in tabs" :class="[curTab==index?'cur':'']" @click="tabClick(index)">{{item}}</a>
        </span>
      </h2>
      <div class="kc_box1">
        <!-- 讲师团队-->
        <div class="list" v-show="tabs[curTab]=='讲师团队'">
          <div class="teacherList">
            <div class="u-item"  v-for="item in classTeacher">
              <span class="userIco">
                <img :src="item.photoUrl" />
              </span>
              <span class="u-right">
                <span class="span1">
                  {{item.name}}
                  <!-- <span>·</span> -->
                 
                </span>
                <span class="span2"> {{item.schoolName}}</span>
              </span>
              <div class="desc">{{item.experience}}</div>
            </div>
            <div class="nodata" v-if="classTeacher==null||classTeacher.length==0">
              <span class="nodata-img"></span>
              <span class="nodata-txt">没有找到数据</span>
            </div>
          </div>
        </div>
         <!-- 导师团队-->
         <div class="list" v-show="tabs[curTab]=='导师团队'">
          <div class="teacherList">
            <div class="u-item"  v-for="item in classTeacher2">
              <span class="userIco">
                <img :src="item.photoUrl" />
              </span>
              <span class="u-right">
                <span class="span1">
                  {{item.name}}
                  <!-- <span>·</span> -->
                 
                </span>
                <span class="span2"> {{item.schoolName}}</span>
              </span>
              <div class="desc">{{item.experience}}</div>
            </div>
            <div class="nodata" v-if="classTeacher2==null||classTeacher2.length==0">
              <span class="nodata-img"></span>
              <span class="nodata-txt">没有找到数据</span>
            </div>
          </div>
        </div>
        <!-- 培训目标-->
        <div class="list"  v-show="tabs[curTab]=='培训目标'">
          <div class="trainPoint" style="padding: 20px 20px;">
            <div class="ck-content" v-html="classData.fullIntroduce"></div>
          </div>
        </div>
        <!-- 课程目录 -->
        <div class="list"  v-show="tabs[curTab]=='课程目录'">
          <div class="trainSection" style="padding: 20px 20px;">
            <div class="ck-content" v-html="classData.courseIntroduce"></div>
          </div>
        </div>
        <!-- 录播课程-->
        <div class="list"   v-show="tabs[curTab]=='录播课程'">
          <div class="dateoption" >
            <span @click="currentType = item.classGroup" :class="[currentType==item.classGroup || (currentType==''&& index==0)?'active':'']" v-for="(item,index) in classCourses">{{item.classGroup==null?"未分类":item.classGroup}}</span>
          </div>
          <div class="kcList" v-for="(item1,index) in classCourses" :key="index"  v-if="currentType==item1.classGroup || (currentType==''&& index==0)" >
            <a class="kebox" href="javascript:void(0)"  v-for="item in item1.subList" @click="clickKcUrl(item)" >
              <img
                :src="item.thumb"
                alt
                class="imgbg"
              />
              <div class="kctitle" :title="item.title">{{item.title}}</div>
              <div class="nums">
                <span class="teacher">{{item.teacherName}}</span>
                <span class="stunum">
                  <img src="Images/icon-scale.png" />
                  <span> {{item.studentNum}}</span>
                </span>
                <span class="startTime" v-if="item.startTime"> {{item.startTime | dateFormat()}} 开课</span>
              </div>
            </a>
            <div class="nodata" v-if="classCourses==null||classCourses.length==0">
              <span class="nodata-img"></span>
              <span class="nodata-txt">没有找到数据</span>
            </div>
          </div>
          <!-- <div class="opr1" v-if="classCourses!=null&&classCoursesPage.total>1">
            <span class="my-course-page">
              <span class="page">{{classCoursesPage.page+1}}/{{classCoursesPage.total}}</span>
              <a class="page-prev prev" @click="pagePrev(2)"></a>
              <a class="page-next next" @click="pageNext(2)"></a>
            </span>
          </div> -->
        </div>
        <!-- 直播课程-->
        <div class="list" v-show="tabs[curTab]=='直播课程'">
          <div class="liveList">
            <div class="zb-item" v-for="item in classLives">
              <div class="img-left">
                <div class="logo-div1"></div>
                <img class="logo" :src="item.logo" />
              </div>
              <div class="info-right">
                <span class="title p-span" :title="item.title">{{item.title}}</span>
                <span class="desc p-span" :title="item.content" style="height: 43px;white-space: normal;">{{item.content}}</span>
                <span class="num p-span" style=" margin-top: 10px;">
                  <span class="teacher" style="margin-left:0">{{item.presenter}}</span>
                  <hr />
                  <img src="Images/time.jpg" />
                  <span>{{item.startTimeS}} 至 {{item.endTimeS}}</span>
                </span>
                <span class="opr p-span">
                  <button
                    v-if="item.state ==2 && item.hasBackPlay==1"
                    class="finished"
                    data-url
                    @click="playback(item)"
                  >观看回放</button>
                  <button v-else-if="item.state == 2 && item.hasBackPlay==0">未录制回放</button>
                  <button v-else-if="item.state == 0 " data-url @click="start(item)">未开始</button>
                  <button v-else data-url @click="start(item)" class="start">进入直播</button>
                </span>
              </div>
            </div>
            <div class="nodata" v-if="classLives==null||classLives.length==0">
              <span class="nodata-img"></span>
              <span class="nodata-txt">没有找到数据</span>
            </div>
          </div>
          <div class="opr1" v-if="classLives!=null&&classLivesPage.total>1">
            <span class="my-course-page">
              <span class="page">{{classLivesPage.page+1}}/{{classLivesPage.total}}</span>
              <a class="page-prev prev" @click="pagePrev(1)"></a>
              <a class="page-next next" @click="pageNext(1)"></a>
            </span>
          </div>
        </div>
        <!-- 阶段测试-->
        <div class="list"  v-show="tabs[curTab]=='阶段测试'" >
          <div class="examlist">
            <div class="item" v-for="item in classExam" v-if="item.isShow">
              <img src="Images/icon-exam.png"/>
              <div class="right">
                <span class="title">{{item.name}}</span>
                <span class="time">开始时间：{{item.startTime | dateFormat2()}}</span>
                <span class="time">结束时间：{{item.endTime | dateFormat2()}}</span>
              </div>
              <button class="btn" @click="EnterUrl(item.url)" :disabled="new Date(item.startTime)>new Date() || new Date()>new Date(item.endTime)" >进入测试</button>
            </div>
            <div class="nodata" v-if="classExam.length==0">
              <span class="nodata-img"></span>
              <span class="nodata-txt">没有找到数据</span>
            </div>
          </div>
          <!-- <a v-show="random < 0.5 || random == 0.5" href="https://ks.wjx.top/vj/mWHcxaj.aspx"><h2 style="font-size:25px">阶段测试</h2></a>
          <a v-show="random > 0.5" href="https://ks.wjx.top/vj/rwV27bg.aspx"><h2 style="font-size:25px">阶段测试</h2></a> -->
          <!--<div class="ConsquentList">
            <div class="fitem" style="height: 40px;color: #333;  font-weight: bold;" v-if="classResults.length>0">
              <span class="filename" style=" text-indent: 32px;">文档名称</span>
              <span class="filesize">大小</span>
              <span class="time">时间</span>
              <span class="user">姓名</span>
              <span class="school">单位</span>
            </div>
            <div class="fitem" v-for="item in classResults">
              <span class="filename" :title="item.fileName">
                <span class="ftype pdf"></span>
                {{item.fileName}}
              </span>
              <span class="filesize">{{item.fileSize|fileSizeFormat()}}</span>
              <span class="time">{{item.createTime|dateFormat()}}</span>
              <span class="user">{{item.uploadBy}}</span>
              <span class="school">{{item.school}}</span>
              <a class="btn_down" @click="downFile(item)">下载</a>
            </div>
            <div class="nodata" v-if="classResults.length==0">
              <span class="nodata-img"></span>
              <span class="nodata-txt">没有找到数据</span>
            </div>
          </div>
          <div class="opr1" v-if="classResultsPage.total>1">
            <span class="my-course-page">
              <span class="page">{{classResultsPage.page+1}}/{{classResultsPage.total}}</span>
              <a class="page-prev prev" @click="pagePrev(0)"></a>
              <a class="page-next next" @click="pageNext(0)"></a>
            </span>
          </div>-->
        </div>
        <!-- 资料下载 -->
        <div class="list"  v-show="tabs[curTab]=='资料下载'" >
          <div class="fileList">
            <div class="fitem" style=" height: 40px;color: #333;  font-weight: bold;" v-if="classFiles.length>0">
              <span class="filename" style="text-indent: 32px;">文档名称</span>
              <span class="filesize">大小</span>
              <span class="time">时间</span>
              <span class="courseName">隶属课程</span>
            </div>
            <div class="fitem" v-for="item in classFiles">
              <span class="filename" :title="item.fileName">
               
                <span v-if="item.resourceId!=0" class="ftype pdf"></span>
                <span v-else class="ftype link"></span>
                {{item.fileName}}
              </span>
              <span v-if="item.resourceId!=0"  class="filesize">{{item.fileSize|fileSizeFormat()}}</span>
              <span v-else class="filesize"></span>
              <span class="time">{{item.creationTimeS}}</span>
              <span class="courseName">{{item.courseName}}</span>
              <a  v-if="item.resourceId!=0"  class="btn_down" @click="downFile(item)" target="_blank">下载</a>
              <a  v-else class="btn_down" :href="item.fileUrl" target="_blank">打开</a>
            </div>
            <div class="nodata" v-if="classFiles.length==0">
              <span class="nodata-img"></span>
              <span class="nodata-txt">没有找到数据</span>
            </div>
              <div class="opr1" v-if="classFilesPage.total>1">
            <span class="my-course-page">
              <span class="page">{{classFilesPage.page+1}}/{{classFilesPage.total}}</span>
              <a class="page-prev prev" @click="pagePrev(3)"></a>
              <a class="page-next next" @click="pageNext(3)"></a>
            </span>
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="desc_box">
      <div class="desc-item">
        <h2>培训班级简介</h2>
        <div class="desc">{{classData.baseSummary}}</div>
      </div>
      <div class="desc-item">
        <h2>班级通知</h2>
        <div class="noticeList">
          <div class="nitem" v-if="classNotices[currentIndex]!=undefined" >
            <span v-if="classNotices[currentIndex].content.length>35 && !classNotices[currentIndex].active">{{classNotices[currentIndex].content.substring(0,35)}}...</span>
            <span v-else>{{classNotices[currentIndex].content}}</span>
            <a @click="showAllTXt(currentIndex)" v-if="!classNotices[currentIndex].active">展开</a>
            <a @click="showAllTXt(currentIndex)" v-if="classNotices[currentIndex].active" class="shou">收起</a>
          </div>
        </div>
      </div>
      <div class="desc-item">
        <h2>学员风采</h2>

        <div class="stulist" >
            <div v-for="(item,index) in classStudent">

                <h2 :class="[item.show?'down':'','schooltitle']" @click="showStudentList(item)" >
                    <span class="icon"></span>
                    <span class="sname" :title="item.schoolName">{{item.schoolName}}</span>
                    <span class="snum">({{item.classStudents.length}})</span>
                    <i></i>
                </h2>
                <div class="stulist_div" v-show="item.show" >
                    <span class="stuitem" v-for="stu in item.classStudents">
                    <img :src="stu.photoUrl" />
                    <span class="name">{{stu.name}}</span>
                    </span>
                </div>
            </div>
        
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
//import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import comFun from "@/common/common";
import store from '@/store/store'
import moment from 'moment'
export default {
  name: "classDetail",
  components: {},
  data() {
    return {
      random:0,
      classId: 0,
      curTab:0,
      currentType:'',
      classData: {},
      classTeacher: [],
      classTeacher2:[],//导师团队
      classStudent: [],
      classExam:[],
      classLives: [],
      classCourses: [],
      classFiles: [],
      classResults: [],
      classNotices:[],

      classResultsPage: {
        page: 0,
        pageSize: 10,
        total: 0,
        classId: 0
      },
      classFilesPage: {
        page: 0,
        pageSize: 10,
        total: 0,
        classId: 0,
      },
      classLivesPage: {
        page: 0,
        pageSize: 6,
        total: 0,
        classId: 0
      },
      classCoursesPage: {
        // page: 0,
        // pageSize: 6,
        // total: 0,
        classId: 0
      },
      tabs:[
        '讲师团队',
        '导师团队', 
        '培训目标', 
        '课程目录', 
        '录播课程', 
        '直播课程', 
        '阶段测试', 
        '资料下载'
      ],
      currentIndex:0, // 当前通知索引
      interval:undefined
    };
  },
  created() {
    this.random = Math.random(0,1);
    this.classId = this.$route.query.id;
    if(this.classId == 3087) {
      this.$router.push({
        name: 'ClassDetailForS',
        query: {
          id: this.classId
        }
      })
    }
    
    this.classResultsPage.classId = this.classId;
    this.classCoursesPage.classId = this.classId;
    this.classLivesPage.classId = this.classId;
    this.classFilesPage.classId=this.classId;
    comFun.getclassDetail(this.classId).then(res => {
      this.classData = res;
      if(!this.classData.classSetting.showTeacher) this.tabs = this.tabs.filter(x =>x!== '讲师团队')
      if(!this.classData.classSetting.showTutor) this.tabs = this.tabs.filter(x =>x!== '导师团队')
      if(!this.classData.classSetting.showTarget) this.tabs = this.tabs.filter(x =>x!== '培训目标')
      if(!this.classData.classSetting.showCourseCategory) this.tabs = this.tabs.filter(x =>x!== '课程目录')
      if(!this.classData.classSetting.showCourse) this.tabs = this.tabs.filter(x =>x!== '录播课程')
      if(!this.classData.classSetting.showLive) this.tabs = this.tabs.filter(x =>x!== '直播课程')
      if(!this.classData.classSetting.showExam) this.tabs = this.tabs.filter(x =>x!== '阶段测试')
      if(!this.classData.classSetting.showFile) this.tabs = this.tabs.filter(x =>x!== '资料下载')
    });
    // 讲师团队
    comFun.getclassTeachers(this.classId,0).then(res => {
      this.classTeacher = res;
    });
    //  导师团队
    comFun.getclassTeachers(this.classId,1).then(res => {
      this.classTeacher2 = res;
    });
    // 阶段测试
    comFun.getclassExam(this.classId).then(res => {
      this.classExam = res;
    });
    comFun.getClassNotice(this.classId).then(res=>{
      if(res.items!=undefined && res.items.length>0) this.classNotices = res.items
    })
    comFun.getclassStudents(this.classId).then(res => {
      // res = res.sort(function (a, b) {
      //       //return a.schoolName. - b.schoolName'
      //       var str1 = ''
      //       var str2 = ''
      //       if (a.schoolName != null) {
      //           var str1arr = a.schoolName.split('.')
      //           str1 = str1arr[0]
      //       } else {
      //           str1 = 999;
      //       }
      //       if (b.schoolName != null) {
      //           var str1arr2 = b.schoolName.split('.')
      //           str2 = str1arr2[0]
      //       } else {
      //           str2 = 999;
      //       }
      //       return str1 - str2
      //   });
      var _students=[];
        res.forEach(element => {
            element.show=false;
            if(element.schoolName==""||element.schoolName==null)
            {
                element.schoolName='其他单位'
            }
             if(element.schoolName.indexOf('景格')==-1
            //  &&element.schoolName.indexOf('同济')==-1
             &&element.schoolName.indexOf('师培')==-1)
             {
               _students.push(element)
             }
        });
      this.classStudent = _students;
    });
    this.getclassCourseList();
    this.getclassLiveList();
    this.getclassResultList();
    this.getclassFileList();
    // comFun.getclasFiles(this.classId).then(res => {
    //   this.classFiles = res;
    // });
     this.interval = setInterval(() => {
        if(this.currentIndex == this.classNotices.length-1) this.currentIndex = 0
        else{   this.currentIndex ++        }
    },6000)
  },
  filters: {
    fileSizeFormat: function(size) {
        var _s=(size/1024/1024).toFixed(2)
      return _s+"M";
    },
    dateFormat: function(dateStr) {
      return moment(dateStr).format('YYYY-MM-DD')
    },
    dateFormat2: function(dateStr) {
       return moment(dateStr).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
     EnterUrl(url){
       window.open(url,'_blank')
     },
     showAllTXt(index){
      if(this.classNotices[index].active == undefined)   this.$set(this.classNotices[index], 'active', 'true')
      else this.$set(this.classNotices[index],'active',!this.classNotices[index].active)
      if(this.classNotices[index].active) clearInterval(this.interval)
      else { 
        this.interval = setInterval(() => {
          if(this.currentIndex == this.classNotices.length-1) this.currentIndex = 0
          else{   this.currentIndex ++        }
        }, 6000)
      }
    },
    getclassResultList() {
      comFun.getclassResult(this.classResultsPage).then(res => {
        this.classResults = res.items;
        this.classResultsPage.total =parseInt( res.totalCount/ this.classResultsPage.pageSize);
       
        if (res.totalCount %  this.classResultsPage.pageSize > 0) {
          this.classResultsPage.total++;
        }
      });
    },
    getclassFileList() {
      comFun.getclassFiles(this.classFilesPage).then(res => {
        this.classFiles = res.items;
        this.classFilesPage.total =parseInt( res.totalCount/ this.classFilesPage.pageSize);
       
        if (res.totalCount %  this.classFilesPage.pageSize > 0) {
          this.classFilesPage.total++;
        }
      });
    },
    getclassCourseList() {
      comFun.getclassCourses(this.classCoursesPage).then(res => {
        this.classCourses = this.GroupByType(res.items);
        //console.log(this.classCourses)
        // this.classCoursesPage.total = parseInt(res.totalCount / this.classCoursesPage.pageSize);
        // if (res.totalCount % this.classCoursesPage.pageSize > 0) {
        //   this.classCoursesPage.total++;
        // }
      });
    },
    getclassLiveList() {
      comFun.getclassLives(this.classLivesPage).then(res => {
        this.classLives = res.items;
        this.classLivesPage.total = parseInt(res.totalCount / this.classLivesPage.pageSize);
        if (res.totalCount % this.classLivesPage.pageSize > 0) {
          this.classLivesPage.total++;
        }
      });
    },
    pagePrev(t) {
      if (t == 0) {
        if (this.classResultsPage.page > 0) {
          this.classResultsPage.page--;
          this.getclassResultList();
        }
      }
      if (t == 1) {
        if (this.classLivesPage.page > 0) {
          this.classLivesPage.page--;
          this.getclassLiveList();
        }
      }
      // if (t == 2) {
      //   if (this.classCoursesPage.page > 0) {
      //     this.classCoursesPage.page--;
      //     this.getclassCourseList();
      //   }
      // }
      if (t == 3) {
        if (this.classFilesPage.page > 0) {
          this.classFilesPage.page--;
          this.getclassFileList();
        }
      }
    },
    pageNext(t) {
      if (t == 0) {
        if (this.classResultsPage.page+1 < this.classResultsPage.total) {
          this.classResultsPage.page++;
          this.getclassResultList();
        }
      }
      if (t == 1) {
        if (this.classLivesPage.page+1 < this.classLivesPage.total) {
          this.classLivesPage.page++;
          this.getclassLiveList();
        }
      }
      // if (t == 2) {
      //   if (this.classCoursesPage.page+1 < this.classCoursesPage.total) {
      //     this.classCoursesPage.page++;
      //     this.getclassCourseList();
      //   }
      // }
      if (t == 3) {
        if (this.classFilesPage.page+1 < this.classFilesPage.total) {
          this.classFilesPage.page++;
          this.getclassFileList();
        }
      }
    },
    collectClass(){
         var _user = store.state.userInfo;
        if (_user == null) {
            store.dispatch('setShowLogin', true) // 显示登录框
            return false;
        }
        //debugger
        if(this.classData.isCollect)
        {
             comFun.delcollectClass(this.classId).then(res => {
                 this.classData.isCollect=false;
             });
        }else
        {
             comFun.collectClass(this.classId).then(res => {
                  this.classData.isCollect=true;
             });
        }
    },
    tabClick(index){
        this.curTab=index
    },
    showStudentList(item){

        if(item.show) item.show=false;
        else item.show=true;
    },
    start(item) {
      comFun.start(item);
    },
    playback(item) {
      comFun.playback(item);
    },
    clickLiveUrl(item) {
      if (item.state == 2 && item.hasBackPlay==1) comFun.playback(item);
      else if (item.state == 0 || item.state == 1) {
        comFun.start(item);
      }
    },
    clickKcUrl(item) {
      //if()
       this.$router.push({
        name: 'CourseDetail',
        query: {
          id: item.id
        }
       })
    },
    GroupByType(items){ // 按照类型分组
      let newArr = [];
      items.forEach((item, i) => {
        let index = -1;
        //some用来查找数组中是否存在某个值
        let isExists = newArr.some((newItem, j) => {
          if (item.classGroup == newItem.classGroup) {
            index = j;
            return true;
          }
        })
        if (!isExists) {
          newArr.push({
            classGroup: item.classGroup,
            // classGroupText:item.classGroup==null?'未分类':item.classGroup,
            subList: [item]
          })
        } else {
          newArr[index].subList.push(item);
        }
        
      })
      return newArr
    },
     validLogined() { //验证是否登录
         var _user = store.state.userInfo;
        if (_user == null) {
            store.dispatch('setShowLogin', true) // 显示登录框
            return false;
        }
        return true
      },
   async downFile(item) { // 下载文档
        var  protocol = document.location.protocol
        var str = item.fileUrl.split("://")
        if(protocol != str[0]+':')  item.fileUrl = protocol + '//' + str[1]  // 判断为http或者https
      
        if (!this.validLogined()) return false
        var output =await comFun.IsJoinClass(this.classId)
        if (!output) {
          var msg = {
            type: 'error',
            text: '对不起，您没有权限访问！'
          }
          this.$store.dispatch('setMsg', msg)
        } else {
          // window.open(item.fileUrl, '_blank')
          if (!!window.ActiveXObject || 'ActiveXObject' in window) {  // 判断是否为IE浏览器
            window.open(item.fileUrl, "_blank");
          } else {
            var xhr = new XMLHttpRequest();
            xhr.open("get", item.fileUrl, true);
            xhr.responseType = "blob";
            xhr.onload = function () {
              if (this.status == 200) {
                var a = document.createElement('a');
                var url = window.URL.createObjectURL(this.response);
                var filename = item.fileName;
                a.href = url;
                a.download = filename;
                a.click();
                a.remove();
            }
          };
            xhr.send();
          }
        }

      
   },
  }
};
</script>

<style lang="scss" scoped>
</style>

